import {
	service,
	BASE_API
} from '@/utils/request'
import {
	getToken
} from '@/utils/auth'
import docHead from 'assets/img/docHead.png'
import momHead from 'assets/img/momHead.png'

/**
 * 静态url
 * [baseUrl 公共域名]
 * @type {[obj]}
 */
const imgPrefix = process.env.BASE_IMGURL
const imgPrefix_qN = process.env.BASE_IMGURL_QN
const audioPrefix = process.env.BASE_AUDIO
const videoPrefix = process.env.BASE_VEDIO
const pdfPrefix = process.env.BASE_PDF
const qnPrefix = process.env.BASE_QN
const qnPrefix2 = process.env.BASE_QN2
const baseUrl = BASE_API
const sdkAppID = process.env.BASE_SDKAPPID
const appIDAt3rd = process.env.BASE_APPIDAT3rd
const BASE_mUrl = process.env.BASE_mUrl
const BASE_wUrl = process.env.BASE_STATIC
const BASE_liveUrl = process.env.BASE_liveUrl
const qNBucketName = process.env.BASE_QNBucketName
const qNBucketName2 = process.env.BASE_QNBucketName2
export var commonUrl = {
	headers: {
		token: getToken()
	}, //通过登录后设置，通过缓存读取，请求中携带（设置方法非最佳，仅临时解决）
	imgPrefix_qN: imgPrefix_qN, //七牛图片前缀
	imgPrefix: imgPrefix, //.net前缀
	qnPrefix2: qnPrefix2 + '/',
	docHead_pic: docHead, //医生默认头像地址
	momHead_pic: momHead, //孕妈默认头像地址
	uploadImg: baseUrl + '/cloud/bbs/v1/upload/uploadFile', //上传图片的服务器地址
	uploadVideo: baseUrl + '/cloud/bbs/v1/upload/newUploadFile', // 上传视频的服务器新地址（返回第一帧图片和分辨率的）
	parseAMR: 'http://118.190.9.9:9696/audioconvert', //amr格式音频前缀
	uploadPdf: baseUrl + '/cloud/bbs/v1/upload/uploadFile',
	mUrl: BASE_mUrl,
	wUrl: BASE_wUrl,
	liveUrl: BASE_liveUrl,
	audioPrefix: audioPrefix, //音频前缀
	videoPrefix: videoPrefix, //视频前缀
	pdfPrefix: pdfPrefix, //pdf前缀
	qnPrefix: qnPrefix,
	sdkAppID: sdkAppID, //im
	appIDAt3rd: appIDAt3rd, //im
	qNBucketName: qNBucketName,
	qNBucketName2: qNBucketName2
}
/**
 * [searchParamsFormatter 将参数格式化为url的参数]
 * @param  {[array]} obj 参数对象
 * @return {[string]}     符合条件的格式化字符串
 */
export function searchParamsFormatter(obj) {
	const params = []
	Object.keys(obj).forEach((key) => {
		let value = obj[key]
		// 如果值为undefined我们将其置空
		if (typeof value === 'undefined') {
			value = ''
		}
		params.push([key, value].join('='))
	})

	return params.join('&')
}

/**
 * [getProvince 获取省]
 * @return {[obj]} 
 */
export function getProvince() {
	return service({
		url: '/cloud/uac/distract/province/list',
		method: 'get',
	})
}

/**
 * [getCityOrArea 获取市、区]
 * @return {[obj]} 
 */
export function getCityOrArea(params) {
	return service({
		url: '/cloud/uac/distract/cityOrArea/list?code=' + params,
		method: 'get'
	})
}

/**
 * [getCityOrArea 获取市、区]
 * @argument params.type 1 城市 2区域
 * @return {[obj]} 
 */
export function getHospital(params) {
	return service({
		url: '/cloud/uac/hospital/hospitalList/' + params.code,
		method: 'get',
	})
}

/**
 * [getSelect 获取职称，科室，审核方式，注册来源等信息集合]
 * @return {[obj]}
 */
export function getSelect() {
	return service({
		url: '/cloud/uac/doctorManager/getSelect',
		method: 'get',
	})
}

export default {
	commonUrl: commonUrl,

	/**
	 * [getHospital 获取医院]
	 * @argument params.type 1 城市 2区域
	 * @return {[obj]} 
	 */
	getHospital: function getHospital(params) {
		return service({
			url: '/cloud/uac/hospital/hospitalList/' + params.code,
			method: 'get',
		})
	},
	/**
	 * [getCityOrArea 获取市、区]
	 * @return {[obj]} 
	 */
	getCityOrArea: function getCityOrArea(code) {
		return service({
			url: '/cloud/uac/distract/cityOrArea/list?code=' + code,
			method: 'get'
		})
	},

	/**
	 * [getProvince 获取省]
	 * @return {[obj]} 
	 */
	getProvince: () => {
		return service({
			url: '/cloud/uac/distract/province/list',
			method: 'get',
		})
	},

	searchHospital: function searchHospital(params) {
		return service({
			url: '/cloud/uac/hospital/hospitalList/search',
			method: 'get',
			params: params
		})
	},

	searchSchool: function searchSchool(params) {
		return service({
			url: '/cloud/uac/university/selectUniversity',
			method: 'get',
			params: params
		})
	},
	/**
	 * [getSelect 获取职称，科室，审核方式，注册来源等信息集合]
	 * @return {[obj]}
	 */
	getSelect() {
		return service({
			url: '/cloud/uac/doctorManager/getSelect',
			method: 'get',
		})
	},

	
	//获取科室
	getdepartmentData() {
		return service({
			url:'/cloud/uac/doctorManager/getDepartments',
			method:'get'
		})
	},

	getAllCity: function getAllCity() {
		return service({
			url: '/cloud/uac/distract/list',
			method: 'get',
			params: {
				pageNum: 1,
				pageSize: 10000
			}
		})
	},
	//简单搜索医院
	getDocInfo(params) {
		return service({
			url: '/cloud/uac/v1/users/doctors/search',
			method: 'get',
			params: params
		})
	},
	//简单搜索孕妈
	getMomInfo(params) {
		return service({
			url: '/cloud/uac/v1/users/mothers/search',
			method: 'get',
			params: params
		})
	},
	/**
	 * [cityExchange 根据code列表获取对应的名称]
	 * @param  {[obj]} params [ityCode的字符串 英文逗号分隔]
	 * @return {[obj]} 
	 */
	cityExchange(params) {
		return service({
			url: '/cloud/uac/distract/city/list',
			method: 'post',
			params: params
		})
	},
	// 同上
	departExchange(params) {
		return service({
			url: '/cloud/uac/doctor/departments/list/ids',
			method: 'post',
			params: params
		})
	},
	// 同上
	jobTitleExchange(params) {
		return service({
			url: '/cloud/uac/doctor/jobTitle/list/ids',
			method: 'post',
			params: params
		})
	},
	// 短连接
	shortUrl(data) {
		return service({
	      url: '/cloud/bbs/v1/app/config/shortURL',
	      method: 'post',
	      data: data
	    })
	},
	// 上传视频签名
	getSignature(data) {
		return service({
	      url: '/cloud/uac/proxy/Common/GetVodUploadSign',
	      method: 'get'
	    })
	},
	// 获取七牛上传的token
	getQNUploadToken(params) {
		return service({
	      url: '/cloud/bbs/v1/upload/uploadToken',
	      method: 'get',
		  params
	    })
	},
	uploadApi(file, filename) {
		const formData = new FormData()
		formData.append('mediaJson', JSON.stringify({ type: 0}))
		formData.append('file', file, filename || file.name)
		return service({
			url: '/cloud/bbs/v1/upload/uploadFile',
			method: 'post',
			data: formData
		})
	}
}



// WEBPACK FOOTER //
// ./src/api/common.js